import React, { useEffect, useState } from 'react';
import { message, DatePicker, Form, Input, Select } from "antd";
import { Button } from "evergreen-ui";
import { MDBCol } from "mdbreact";
import FireFetch from "../../Firebase/FireFetch";
import Firebase from "../../Firebase/Firebase";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


var auth = getAuth(Firebase);
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");
const AddTask = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateTask = canAccessModule("TASKS", "create");
	const [showLoading, setShowLoading] = useState(false);
	const [taskFile, setTaskFile] = useState(null);
	const [taskImage, setTaskImage] = useState(null);
	const [userID, setUserID] = useState(null);
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [dueDate, setDueDate] = useState(null);
	console.log('uses', userArray);
	useEffect(() => {
		onAuthStateChanged(auth, function (user) {
			if (user) {
				//userArray[userArray.findIndex(x => (user.uid) === x.id)]&&
				//setUserID(userArray[userArray.findIndex(x => (user.uid) === x.id)].userID);
				var id = userArray[userArray.findIndex(x => (user.uid) === x.id)] &&
					userArray[userArray.findIndex(x => (user.uid) === x.id)].id;
				setUserID(id);
			}
		});
	}, [userArray]);

	function onChange(value, dateString) {
		setDueDate(dateString);
	}

	const handleFileUpload = (e) => {
		setTaskFile(e.target.files[0]);
	}

	const handleImage = (e) => {
		setTaskImage(e.target.files[0]);
	}

	const addTask = (values) => {
		if (!canCreateTask) {
			message.error("You do not have permission to create tasks.");
			return;
		}

		console.log(userID);
		setShowLoading(true);

		var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
		var createdDate = moment().format("YYYY-MM-DD");
		var objectID = Array(20).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")
			.map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');

		var object = {
			"task": values.task ? values.task : "",
			"taskID": objectID,
			"taskLink": values.taskLink ? values.taskLink : "",
			"repeat": values.repeat ? values.repeat : "",
			"repeatEvery": values.repeatEvery ? values.repeatEvery : "",
			"description": values.description ? values.description : "",
			"createdDate": createdDate,
			"dueDate": dueDate ? dueDate : "",
			"createdBy": userID,
			"assignedTo": values.assigned ? values.assigned : "",
			"taskImageKeywords": values.keywords ? values.keywords : "",
			"taskStatus": values.status ? values.status : "",
			"dateCreated": timeStamp
		}

		console.log(userArray)

		const output = FireFetch.SaveTODB("Tasks", objectID, object);
		output.then((result) => {
			console.log(result);
			if (result === "success") {
				FireFetch.addLog("Tasks", objectID, "Create");
				message.success("Task created successfully");
				props.modal(false);
				setShowLoading(false);
				uploadBytes(storageRef(storage, "talmidsdb/Tasks/" + objectID + "/taskImage"), taskImage)
					.then(function (snapshot) {
						console.log('Uploaded a blob or file!');
					}).then(() => {
						uploadBytes(storageRef(storage, "talmidsdb/Tasks/" + objectID + "/taskAttachment"), taskFile)
							.then(function (snapshot) {
								console.log('Uploaded a blob or file!');
							}).catch((error) => {
								console.log(error)
							});
					})
			} else {
				message.error("Unable to create task, an error occurred :: " + result);
			}
		});
	}

	return (
		<>
			<MDBCol md={12}>
				<Form
					layout="vertical"
					onFinish={addTask}
					initialValues={{
						status: "Pending",
						//createdBy: userID
					}}
				>
					<Form.Item label="Task"
						name="task"
						rules={[{ required: true, message: 'Please input task name!' }]}>
						<Input placeholder="enter task name" id="task" />
					</Form.Item>
					<Form.Item label="Assigned"
						name="assigned"
						rules={[{ required: true, message: 'Please input Assigned user name!' }]}>
						<Select placeholder="Select user assigned"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{userArray?.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
								<Select.Option value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Description"
						name="description">
						<Input type="text" placeholder="enter task description" id="desc" />
					</Form.Item>
					<Form.Item label="Task Image">
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleImage}
							placeholder="task image" id="task-image" />
					</Form.Item>
					<Form.Item label="Task Link"
						name="taskLink">
						<Input type="text" placeholder="task link" id="link" />
					</Form.Item>
					<Form.Item label="Task Image Keywords"
						name="keywords">
						<Input type="text" placeholder="task image keywords" id="keywords" />
					</Form.Item>
					<Form.Item label="Due Date"
						name="dueDate">
						<DatePicker onChange={onChange} style={{ width: "100%" }} />
					</Form.Item>

					<Form.Item label="Repeat"
						name="repeat">
						<Select placeholder="Select task repeat"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Yes", "No"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Repeat Every"
						name="repeatEvery">
						<Select placeholder="Select task repeat frequency"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Daily", "Weekly", "Monthly", "Yearly"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Task Status"
						name="status">
						<Select placeholder="Select task status"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Pending", "Done"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="File">
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleFileUpload}
							placeholder="task file" id="task-file" />
					</Form.Item>
					<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canCreateTask}>
						Create
					</Button>
				</Form>
			</MDBCol>
		</>
	)
}

export default AddTask;
